// 5개의 점으로 만들 수 있는 모든 오각형 순서 (점 0 고정, 나머지 4점의 순열 = 4! = 24가지)
import { StampPattern } from './types';

export const ORDER_PATTERNS = [
    [0, 1, 2, 3, 4],
    [0, 1, 2, 4, 3],
    [0, 1, 3, 2, 4],
    [0, 1, 3, 4, 2],
    [0, 1, 4, 2, 3],
    [0, 1, 4, 3, 2],
    [0, 2, 1, 3, 4],
    [0, 2, 1, 4, 3],
    [0, 2, 3, 1, 4],
    [0, 2, 3, 4, 1],
    [0, 2, 4, 1, 3],
    [0, 2, 4, 3, 1],
    [0, 3, 1, 2, 4],
    [0, 3, 1, 4, 2],
    [0, 3, 2, 1, 4],
    [0, 3, 2, 4, 1],
    [0, 3, 4, 1, 2],
    [0, 3, 4, 2, 1],
    [0, 4, 1, 2, 3],
    [0, 4, 1, 3, 2],
    [0, 4, 2, 1, 3],
    [0, 4, 2, 3, 1],
    [0, 4, 3, 1, 2],
    [0, 4, 3, 2, 1],
];

export const STAMP_PATTERNS: StampPattern[] = [
    {
        angle0: 34.695,
        angle1: 90,
        angle2: 90,
        angle3: 126.87,
        angle4: 161.565,
        ratio0: 1,
        ratio1: 1,
        ratio2: 1,
        ratio3: 1.054,
        ratio4: 1.581,
    },
];
